import { render, staticRenderFns } from "./ProjectEditingSettings.vue?vue&type=template&id=6b21031f&scoped=true&"
import script from "./ProjectEditingSettings.vue?vue&type=script&lang=ts&"
export * from "./ProjectEditingSettings.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectEditingSettings.vue?vue&type=style&index=0&id=6b21031f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b21031f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VProgressCircular,VRow,VSnackbar,VTextField})
